module.exports = __webpack_public_path__ + "media/promo/panasonic/images/thumb-38048784a68d6b240096cfce2f59b70f.svg";